import { Collections } from "@core/constants/FirebasePaths";
import { Queries } from "@core/constants/Queries";
import { useFirebaseData } from "@shared/hooks/useFirebaseData";
import { useUserSessionStore } from "stores/UserSession.store";
import { ILocation } from "../../@core/interfaces/ILocation";

export const useLocations = (loadData = false) => {
  const user = useUserSessionStore((state) => state.user);
  const { getReference } = useFirebaseData({ loadData: false });
  const db = useFirebaseData<ILocation>({
    collectionPath: `${Collections.locations._path}`,
    loadData,
    queries: [
      ...Queries.trash,
      {
        type: 'where',
        field: 'company',
        operator: '==',
        value: getReference(`users/${user.id}`)
      }
    ]
  });

  const createLocation = async (data: Partial<ILocation>) => {
    const { lastLocationId } = await db.updateSequenceData(`${Collections.settings._path}/location`, (settings) => ({ lastLocationId: (settings?.lastLocationId || 0) + 1 }))

    return await db.add({
      ...data,
      company: db.getReference(`users/${user.id}`),
      active: true,
      lastLocationId
    });
  };

  const updateLocation = async (id: string, data: Partial<ILocation>) => {
    await db.update(id, data);
  };

  const deleteLocation = async (id: string) => {
    await db.trash(id);
  };

  return {
    getReference: db.getReference,
    locations: db.data,
    createLocation,
    updateLocation,
    deleteLocation,
    fetched: db.fetched
  };
};
